enum Color {
  BLACK = '#000000',
  GRAY_9 = '#1E1818',
  GRAY_8 = '#393838',
  GRAY_7 = '#666A6A',
  GRAY_6 = '#9C9E9F',
  GRAY_5 = '#B7B8B8',
  GRAY_4 = '#DFDFDF',
  GRAY_3 = '#ECEDEE',
  GRAY_2 = '#F9F9F9',
  GRAY_1 = '#FAFAFA',
  WHITE = '#ffffff',
  BLUE_GRAY_10 = '#293942',
  BLUE_GRAY_9 = '#43525a',
  BLUE_GRAY_8 = '#313440',
  BLUE_GRAY_7 = '#849ca8',
  BLUE_GRAY_6 = '#a7bac3',
  BLUE_GRAY_5 = '#b4c8d2',
  BLUE_GRAY_4 = '#cfdbe1',
  BLUE_GRAY_3 = '#e6ebee',
  BLUE_GRAY_2 = '#eaf1f5',
  BLUE_GRAY_1 = '#f2f6f9',
  BLUE_10 = '#002054',
  BLUE_9 = '#00337a',
  BLUE_8 = '#0048a1',
  BLUE_7 = '#016ed3',
  BLUE_6 = '#1787ee',
  BLUE_5 = '#4e9cf6',
  BLUE_4 = '#6fb2f0',
  BLUE_3 = '#acd0f2',
  BLUE_2 = '#c8e4ff',
  BLUE_1 = '#e4f1fd',
  RED_10 = '#5c0c11',
  RED_9 = '#821216',
  RED_8 = '#a82020',
  RED_7 = '#e0362b',
  RED_6 = '#f2584e',
  RED_5 = '#ff8173',
  RED_4 = '#ffaaa4',
  RED_3 = '#fccfd1',
  RED_2 = '#fcebea',
  RED_1 = '#fff3f0',
  ORANGE_10 = '#571c04',
  ORANGE_9 = '#7d2d07',
  ORANGE_8 = '#a34512',
  ORANGE_7 = '#c96120',
  ORANGE_6 = '#ef8132',
  ORANGE_5 = '#ffa458',
  ORANGE_4 = '#ffc187',
  ORANGE_3 = '#ffd9b0',
  ORANGE_2 = '#ffeed9',
  ORANGE_1 = '#fff9f0',
}

export default Color;
